export default class fvRenderScript {
    constructor(){

    }
    
    InitColor(pColor,pColorNum,m_RendType,color) {//初始化颜色
        for (var i = 0; i < pColorNum.value; i++)
            pColor[i] = color[i];
        //如果颜色只有一种，利用m_Type初始化颜色
        if (pColorNum.value != 1) {
            return;
        }
        var r0, g0, b0;
        var r, g, b;
        var r1, g1, b1;
        var tr, tg, tb;
        var rgbArray = pColor[0].colorRgb();
        r0 = rgbArray[0];
        g0 = rgbArray[1];
        b0 = rgbArray[2];
        switch (parseInt(m_RendType)) {
            case 0:				//从暗到亮
                r = r0 / 2;
                g = g0 / 2;
                b = b0 / 2;
                var tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[0] = tempRGB.colorHex();
                tr = r0 + (255 - r0) / 8 + r0 / 2;
                tg = g0 + (255 - g0) / 8 + g0 / 2;
                tb = b0 + (255 - b0) / 8 + b0 / 2;
                r = tr > 255 ? 255 : tr;
                g = tg > 255 ? 255 : tg;
                b = tb > 255 ? 255 : tb;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[1] = tempRGB.colorHex();
                pColorNum.value = 2;
                break;
            case 1:				//从亮到暗
                tr = r0 + (255 - r0) / 8 + r0 / 2;
                tg = g0 + (255 - g0) / 8 + g0 / 2;
                tb = b0 + (255 - b0) / 8 + b0 / 2;
                r = tr > 255 ? 255 : tr;
                g = tg > 255 ? 255 : tg;
                b = tb > 255 ? 255 : tb;
                var tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[0] = tempRGB.colorHex();
                r = r0 / 2;
                g = g0 / 2;
                b = b0 / 2;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[1] = tempRGB.colorHex();
                pColorNum.value = 2;
                break;
            case 2:				//暗到亮到暗
                r = r0 / 2;
                g = g0 / 2;
                b = b0 / 2;
                var tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[0] = tempRGB.colorHex();
                tr = r0 + (255 - r0) / 8 + r0 / 2;
                tg = g0 + (255 - g0) / 8 + g0 / 2;
                tb = b0 + (255 - b0) / 8 + b0 / 2;
                r = tr > 255 ? 255 : tr;
                g = tg > 255 ? 255 : tg;
                b = tb > 255 ? 255 : tb;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[1] = tempRGB.colorHex();
                pColor[2] = pColor[0];
                pColorNum.value = 3;
                break;
            case 3:				//亮到暗到亮
                tr = r0 + (255 - r0) / 8 + r0 / 2;
                tg = g0 + (255 - g0) / 8 + g0 / 2;
                tb = b0 + (255 - b0) / 8 + b0 / 2;
                r = tr > 255 ? 255 : tr;
                g = tg > 255 ? 255 : tg;
                b = tb > 255 ? 255 : tb;
                var tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[0] = tempRGB.colorHex();
                r = r0 / 2;
                g = g0 / 2;
                b = b0 / 2;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[1] = tempRGB.colorHex();
                pColor[2] = pColor[0];
                pColorNum.value = 3;
                break;
            case 4:				//金属反光效果
                r = r0 / 2;
                g = g0 / 2;
                b = b0 / 2;
                var tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[0] = tempRGB.colorHex();
                tr = r0 + (255 - r0) / 8 + r0 / 2;
                tg = g0 + (255 - g0) / 8 + g0 / 2;
                tb = b0 + (255 - b0) / 8 + b0 / 2;
                r1 = r = tr > 255 ? 255 : tr;
                g1 = g = tg > 255 ? 255 : tg;
                b1 = b = tb > 255 ? 255 : tb;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[3] = tempRGB.colorHex();
                r = (r0 + r1) / 3;
                g = (g0 + g1) / 3;
                b = (b0 + b1) / 3;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[1] = tempRGB.colorHex();
                r = (r0 + r1 * 2) / 3;
                g = (g0 + g1 * 2) / 3;
                b = (b0 + b1 * 2) / 3;
                tempRGB = "RGB("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
                pColor[2] = tempRGB.colorHex();
                pColor[4] = pColor[1];
                pColor[5] = pColor[2];
                pColor[6] = pColor[0];
                pColorNum.value = 7;
                break;
            default:
                //ASSERT(0);	//类型错误
                break;
        }
        return pColorNum.value;
    }

    RotateTo2Pi(obj) {
        var ntemp = parseInt(obj.value / (3.1415926 * 2.0));
        obj.value = obj.value - parseFloat(ntemp * (3.1415926 * 2.0));
        if (obj.value < 0)
            obj.value += 3.1415926 * 2.0;
    }

    Split(all, grade) {
        var nSplit;
        var rat = [1.0, 0.5, 0.25, 0.18, 0.1];
        var max = [100, 80, 50, 40, 30];
        var index = grade;
        var computrat = rat[grade];
        if (all <= 50 && all > 20) {
            if (grade > 0)
                computrat = (rat[index - 1] - rat[index]) * (50 - all) / 30.0 + rat[index];
        }
        else if (all <= 20) {
            if (grade > 1)
                computrat = (rat[index - 2] - rat[index - 1]) * (20 - all) / 20.0 + rat[index - 1];
        }
        nSplit = parseFloat(all * computrat);
        if (nSplit > max[grade])
            nSplit = max[grade];
        if (nSplit <= 1)
            nSplit = 2;
        return nSplit;
    }
}


// WEBPACK FOOTER //
// ./src/js/render/fvRenderScript.js